import './sidebar.css'
import close from '../../assets/images/close.png'
import { Link } from 'react-router-dom'

const Sidebar = ({ toggle, setToggle }) => {
    return (
        <div className={`sidebar ${toggle && 'left-width'}`}>
            <div className="sidebar-header">
                <div className="sidebar-close">
                    <img src={close} alt="" onClick={() => setToggle(false)} />
                </div>
                <div className="sidebar-cont">
                    <div className="sidebar-pic user-pic">
                        <img
                            src="https://templates.hibotheme.com/bixu/default/assets/images/team/team-img-2.png" alt="" />
                        <div className="div">
                            <Link>Username</Link>
                            <Link>Logout</Link>
                        </div>
                    </div>
                    <div className="sidebar-links">
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/services">Services</Link></li>
                            <li><Link to="/blogs">Blogs</Link></li>
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                    <div className="sidebar-account" style={{ marginBottom: '1.5rem' }}>
                        <Link to="/login" className='default-btn'>Login</Link>
                    </div>
                    <div className="sidebar-account">
                        <Link to="/provider-login" className='default-btn'>Service Provider</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar